<template>
  <span v-if="value" class="font-weight-bold">
    {{ getText() }}
  </span>
  <span v-else></span>
</template>

<script>
export default {
  name: 'serverDisplay',
  props: {
    value: {
      required: true
    }
  },
  methods: {
    getText() {
      let value = this.value.trim()
      if (value.includes('null')) {
        return ''
      } else if (value === 'Pickup Tab' || value === 'Dine In' || value === 'Dine In Tab' || value === 'Delivery Tab') {
        return ''
      } else {
        let [first, second] = value.split(' ')
        return '(' + first + ' ' + second.substring(0, 1) + ')'
      }
    }
  }
}
</script>

<style></style>
